import { makeStyles } from '@material-ui/core';

const useLoadingStyles = makeStyles((theme) => {
  return ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '30vh'
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  });
});

export default useLoadingStyles;